import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiArrowUpRight} = FiIcons;
const LOGO_URL = 'https://www.progresulbaiamare.ro/wp-content/uploads/brizy/imgs/logo-fundal-alb-pbm-386x386x0x68x386x248x1767111984.png';

export default function SiteHeader() {
  return (
    <header className="site-header">
      <div className="brand">
        <img className="brand-logo" src={LOGO_URL} alt="Logo Progresul Baia Mare" />
        <strong className="brand-title">PROGRESUL BAIA MARE</strong>
      </div>
      <a className="site-link" href="https://www.progresulbaiamare.ro/" target="_blank" rel="noopener noreferrer">
        Website-ul clubului <SafeIcon icon={FiArrowUpRight} />
      </a>
    </header>
  );
}